import React from "react";
import { makeStyles, CardContent, Typography } from "@material-ui/core";
import FormButton from "../forms/FormButton";
import DatePickerToFrom from "../elements/DatePickerToFrom";

const useStyles = makeStyles((theme) => ({
  buttonGroup: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));

const ImportHistoricData = ({
  title,
  id,
  waiting,
  onRefresh,
  onStartDateChanged,
  dateTimeValue,
  closeModal,
}) => {
  const classes = useStyles();

  const setTimestamp = (timestamp, timezone) =>
    timezone ? timestamp.clone().tz() : timestamp;

  return (
    <CardContent>
      <Typography variant="h3" gutterBottom>
        {title}
      </Typography>

      <DatePickerToFrom
        timestampFrom={setTimestamp(dateTimeValue.start_date)}
        onChangeFrom={onStartDateChanged}
        maxDays={90}
        color="green"
        disableTo={true}
      />
      <div className={classes.buttonGroup}>
        <FormButton text="Close" handleClick={closeModal} />
        <FormButton
          text="REFRESH"
          disabled={waiting}
          handleClick={() => onRefresh()}
          variant="contained"
          color="primary"
          waiting={waiting}
          waitingText="refreshing"
        />
      </div>
      {waiting && (
        <Typography gutterBottom>
          Refreshing, this may take few minutes
        </Typography>
      )}
    </CardContent>
  );
};

export default ImportHistoricData;
